module.exports = __webpack_public_path__ + "img/vat_needed-true.b786933b.png";